import React, { SVGProps } from "react";

const Phone: React.FC<SVGProps<SVGSVGElement>> = props => (
	<svg width="134" height="248" viewBox="0 0 134 248" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g clip-path="url(#clip0)">
			<g opacity="0.22">
				<path
					opacity="0.22"
					d="M54.2413 169.588L0.620605 200.545L71.4827 241.08L125.103 210.123L54.2413 169.588Z"
					fill="white"
				/>
				<path
					opacity="0.22"
					d="M54.2414 169.588L1.82764 199.861L72.6897 240.396L125.104 210.123L54.2414 169.588Z"
					fill="#FBFBFB"
				/>
				<path
					opacity="0.22"
					d="M54.2421 169.588L3.03516 199.177L73.8972 239.712L125.104 210.123L54.2421 169.588Z"
					fill="#F6F6F8"
				/>
				<path
					opacity="0.22"
					d="M54.2413 169.588L4.06885 198.492L74.9309 239.028L125.103 210.123L54.2413 169.588Z"
					fill="#F2F2F4"
				/>
				<path
					opacity="0.22"
					d="M54.2414 169.588L5.27588 197.808L76.1379 238.343L125.103 210.123L54.2414 169.588Z"
					fill="#EDEDF0"
				/>
				<path
					opacity="0.22"
					d="M54.242 169.588L6.4834 197.124L77.3455 237.83L125.104 210.123L54.242 169.588Z"
					fill="#E9E9ED"
				/>
				<path
					opacity="0.22"
					d="M54.2412 169.588L7.51709 196.44L78.3792 237.146L125.103 210.123L54.2412 169.588Z"
					fill="#E4E4E9"
				/>
				<path
					opacity="0.22"
					d="M54.2419 169.588L8.72461 195.927L79.5867 236.462L125.104 210.123L54.2419 169.588Z"
					fill="#E0E0E6"
				/>
				<path
					opacity="0.22"
					d="M54.242 169.588L9.93164 195.243L80.7937 235.778L125.104 210.123L54.242 169.588Z"
					fill="#DBDBE2"
				/>
				<path
					opacity="0.22"
					d="M54.2412 169.588L10.9653 194.559L81.8274 235.094L125.103 210.123L54.2412 169.588Z"
					fill="#D7D7DE"
				/>
				<path
					opacity="0.22"
					d="M54.2418 169.588L12.1729 193.875L83.0349 234.41L125.104 210.123L54.2418 169.588Z"
					fill="#D2D2DB"
				/>
				<path
					opacity="0.22"
					d="M54.242 169.588L13.3799 193.19L84.242 233.726L125.104 210.123L54.242 169.588Z"
					fill="#CECED7"
				/>
				<path
					opacity="0.22"
					d="M54.2412 169.588L14.4136 192.506L85.2756 233.041L125.103 210.123L54.2412 169.588Z"
					fill="#C9C9D3"
				/>
				<path
					opacity="0.22"
					d="M54.2418 169.588L15.6211 191.822L86.4832 232.357L125.104 210.123L54.2418 169.588Z"
					fill="#C5C5D0"
				/>
				<path
					opacity="0.22"
					d="M54.2419 169.588L16.8281 191.138L87.6902 231.844L125.104 210.123L54.2419 169.588Z"
					fill="#C1C1CC"
				/>
				<path
					opacity="0.22"
					d="M54.2411 169.588L17.8618 190.454L88.7239 231.16L125.103 210.123L54.2411 169.588Z"
					fill="#BCBCC8"
				/>
				<path
					opacity="0.22"
					d="M54.2418 169.588L19.0693 189.77L89.9314 230.476L125.104 210.123L54.2418 169.588Z"
					fill="#B8B8C5"
				/>
				<path
					opacity="0.22"
					d="M54.2419 169.588L20.2764 189.257L91.1384 229.792L125.104 210.123L54.2419 169.588Z"
					fill="#B3B3C1"
				/>
				<path
					opacity="0.22"
					d="M54.2411 169.588L21.3101 188.572L92.1721 229.108L125.103 210.123L54.2411 169.588Z"
					fill="#AFAFBE"
				/>
				<path
					opacity="0.22"
					d="M54.2417 169.588L22.5176 187.888L93.3796 228.423L125.104 210.123L54.2417 169.588Z"
					fill="#AAAABA"
				/>
				<path
					opacity="0.22"
					d="M54.2419 169.588L23.7246 187.204L94.5867 227.739L125.104 210.123L54.2419 169.588Z"
					fill="#A6A6B6"
				/>
				<path
					opacity="0.22"
					d="M54.2411 169.588L24.7583 186.52L95.6204 227.055L125.103 210.123L54.2411 169.588Z"
					fill="#A1A1B3"
				/>
				<path
					opacity="0.22"
					d="M54.2417 169.588L25.9658 185.836L96.8279 226.371L125.104 210.123L54.2417 169.588Z"
					fill="#9D9DAF"
				/>
				<path
					opacity="0.22"
					d="M54.2418 169.588L27.1729 185.152L98.0349 225.858L125.104 210.123L54.2418 169.588Z"
					fill="#9898AB"
				/>
				<path
					opacity="0.22"
					d="M54.2415 169.588L28.207 184.468L99.0691 225.174L125.104 210.123L54.2415 169.588Z"
					fill="#9494A8"
				/>
				<path
					opacity="0.22"
					d="M54.2417 169.588L29.4141 183.783L100.276 224.49L125.104 210.123L54.2417 169.588Z"
					fill="#8F8FA4"
				/>
				<path
					opacity="0.22"
					d="M54.2418 169.588L30.6211 183.27L101.483 223.806L125.104 210.123L54.2418 169.588Z"
					fill="#8B8BA1"
				/>
				<path
					opacity="0.22"
					d="M54.2415 169.588L31.6553 182.586L102.517 223.121L125.104 210.123L54.2415 169.588Z"
					fill="#86869D"
				/>
				<path
					opacity="0.22"
					d="M54.2416 169.588L32.8623 181.902L103.724 222.437L125.104 210.123L54.2416 169.588Z"
					fill="#828299"
				/>
				<path
					opacity="0.22"
					d="M54.2418 169.588L34.0693 181.218L104.931 221.753L125.104 210.123L54.2418 169.588Z"
					fill="#7E7E96"
				/>
				<path
					opacity="0.22"
					d="M54.2414 169.588L35.1035 180.534L105.966 221.069L125.104 210.123L54.2414 169.588Z"
					fill="#797992"
				/>
				<path
					opacity="0.22"
					d="M54.2416 169.588L36.3105 179.85L107.173 220.385L125.104 210.123L54.2416 169.588Z"
					fill="#75758E"
				/>
				<path
					opacity="0.22"
					d="M54.2422 169.588L37.5181 179.166L108.38 219.701L125.104 210.123L54.2422 169.588Z"
					fill="#70708B"
				/>
				<path
					opacity="0.22"
					d="M54.2414 169.588L38.5518 178.481L109.414 219.188L125.103 210.123L54.2414 169.588Z"
					fill="#6C6C87"
				/>
				<path
					opacity="0.22"
					d="M54.2416 169.588L39.7588 177.797L110.621 218.503L125.104 210.123L54.2416 169.588Z"
					fill="#676783"
				/>
				<path
					opacity="0.22"
					d="M54.2422 169.588L40.9663 177.284L111.828 217.819L125.104 210.123L54.2422 169.588Z"
					fill="#636380"
				/>
				<path
					opacity="0.22"
					d="M54.2414 169.588L42 176.6L112.862 217.135L125.103 210.123L54.2414 169.588Z"
					fill="#5E5E7C"
				/>
				<path
					opacity="0.22"
					d="M54.2415 169.588L43.207 175.916L114.069 216.451L125.104 210.123L54.2415 169.588Z"
					fill="#5A5A79"
				/>
				<path
					opacity="0.22"
					d="M54.2421 169.588L44.4146 175.232L115.277 215.767L125.104 210.123L54.2421 169.588Z"
					fill="#555575"
				/>
				<path
					opacity="0.22"
					d="M54.2413 169.588L45.4482 174.548L116.31 215.083L125.103 210.123L54.2413 169.588Z"
					fill="#515171"
				/>
				<path
					opacity="0.22"
					d="M54.2415 169.588L46.6553 173.863L117.517 214.399L125.104 210.123L54.2415 169.588Z"
					fill="#4C4C6E"
				/>
				<path
					opacity="0.22"
					d="M54.2412 169.588L47.6895 173.179L118.724 213.715L125.103 210.123L54.2412 169.588Z"
					fill="#48486A"
				/>
			</g>
			<path
				d="M50.6202 3.68353L49.9306 4.88076C48.8961 5.5649 48.5513 9.84076 48.5513 10.867V158.983C48.5513 166.166 53.3789 175.232 59.5857 178.823L115.448 210.807C116.31 211.32 119.758 212.175 120.62 211.833L127.862 209.268C130.275 208.412 131.827 206.189 131.827 203.623V50.547C131.827 43.3636 126.827 34.6408 120.62 31.2201L69.7582 2.14422C63.3789 -1.44751 56.4823 -0.250265 50.6202 3.68353Z"
				fill="url(#paint0_linear)"
			/>
			<path
				d="M59.413 3.85421C53.2061 0.262477 48.2061 3.17007 48.2061 10.3535V159.838C48.2061 167.021 53.2061 175.743 59.413 179.164L114.068 210.463C120.275 214.055 125.275 211.147 125.275 203.964V54.4804C125.275 47.297 120.275 38.5742 114.068 35.1535L59.413 3.85421Z"
				fill="#F9F7F9"
			/>
			<path d="M54.4121 28.3108V149.061L119.067 186.005V65.2542L54.4121 28.3108Z" fill="#D3DAED" />
			<path
				d="M95.2745 38.9151C95.102 38.9151 94.7572 38.9151 94.5848 38.744L77.5158 28.9951C76.8262 28.653 76.6538 27.7978 76.9986 27.2847C77.3434 26.6006 78.2055 26.4296 78.7227 26.7716L95.7917 36.5206C96.4813 36.8627 96.6538 37.7178 96.3089 38.2309C96.1365 38.573 95.7917 38.9151 95.2745 38.9151Z"
				fill="#99A7D8"
			/>
			<path
				d="M86.6553 172.494C82.8622 170.27 79.9312 171.98 79.9312 176.427C79.9312 180.703 83.0346 186.005 86.6553 188.229C90.4484 190.452 93.3794 188.571 93.3794 184.295C93.3794 180.019 90.4484 174.717 86.6553 172.494Z"
				fill="#EDF0F8"
			/>
			<path
				d="M43.8974 246.724L57.5181 239.712C58.8974 239.028 58.8974 237.146 57.5181 236.462L57.3456 236.291C54.9319 235.094 52.1732 234.923 49.7594 235.778L39.587 238.172C38.3801 238.343 37.5181 239.37 37.5181 240.567V242.79C37.5181 243.645 38.0353 244.501 38.8974 245.014L41.3112 246.382C42.0008 247.237 43.0353 247.237 43.8974 246.724Z"
				fill="#48486A"
			/>
			<path
				d="M50.7928 239.37L50.6203 239.199C48.5514 238.172 46.9996 236.804 44.7583 237.488L39.0686 238.515L38.2065 240.225C38.2065 241.08 38.7238 241.764 39.4134 242.277L41.4824 243.475C42.1721 243.988 43.2065 243.988 43.8962 243.475L50.6203 240.054C50.7928 239.883 50.9652 239.883 51.1376 239.712C51.1376 239.712 50.9652 239.541 50.7928 239.37Z"
				fill="#F2B1B5"
			/>
			<path
				d="M29.7587 239.197L43.3794 232.185C44.7587 231.5 44.7587 229.619 43.3794 228.935L43.207 228.764C40.7932 227.567 38.0346 227.396 35.6208 228.251L25.4484 230.645C24.2415 230.816 23.3794 231.843 23.3794 233.04V235.263C23.3794 236.118 23.8966 236.974 24.7587 237.487L27.1725 238.855C27.8622 239.539 28.8966 239.539 29.7587 239.197Z"
				fill="#48486A"
			/>
			<path
				d="M36.6546 231.842L36.4822 231.671C34.4132 230.645 32.8615 229.277 30.6201 229.961L24.9304 230.987L24.0684 232.698C24.0684 233.553 24.5856 234.237 25.2753 234.75L27.3442 235.947C28.0339 236.46 29.0684 236.46 29.758 235.947L36.4822 232.527C36.6546 232.355 36.827 232.355 36.9994 232.184C36.9994 232.013 36.827 231.842 36.6546 231.842Z"
				fill="#F2B1B5"
			/>
			<path
				d="M27.6901 235.434C25.2763 235.434 24.4143 233.553 24.4143 231.329L25.2763 206.7L23.7246 182.071C23.7246 179.848 25.4487 177.967 27.6901 177.967C29.9315 177.967 35.1039 179.677 35.1039 181.9L32.6901 206.7L31.8281 231.5C31.6556 233.553 29.9315 235.434 27.6901 235.434Z"
				fill="#F2B1B5"
			/>
			<path
				d="M42.3445 243.473C42.1721 243.473 41.9998 243.473 41.9998 243.473C39.7584 243.302 38.8962 241.249 39.241 239.026L41.6548 207.555L35.9653 186.005C35.6205 183.782 39.4134 186.347 41.6548 186.005C43.8962 185.663 47.8619 182.755 48.2067 184.979L49.7584 207.213L46.4826 239.71C46.3102 241.933 44.4134 243.473 42.3445 243.473Z"
				fill="#F2B1B5"
			/>
			<path
				d="M26.4827 157.442L25.2758 160.692C24.5862 162.573 24.2413 164.625 24.4138 166.507L24.7586 172.836L20.4482 193.702C24.2413 201.569 43.3793 206.871 50.4482 201.569L48.8965 174.033C49.4138 171.638 49.5862 169.072 49.4138 166.678L49.0689 161.718L26.4827 157.442Z"
				fill="url(#paint1_linear)"
			/>
			<path
				d="M30.6203 159.494C29.4134 159.494 28.3789 158.981 27.6893 157.783L21.6548 147.521C15.4479 136.917 18.2065 123.234 28.0341 115.709L29.5858 114.512C30.9651 113.485 33.0341 113.656 34.241 115.196C35.2755 116.564 35.1031 118.616 33.5513 119.814L31.9996 121.011C24.7582 126.484 22.6893 136.575 27.3444 144.272L33.3789 154.534C34.241 156.073 33.7238 158.125 32.172 158.981C31.6548 159.323 31.1375 159.494 30.6203 159.494Z"
				fill="#F2B1B5"
			/>
			<path
				d="M34.4141 115.196C33.3797 113.828 31.3107 113.486 29.759 114.512L28.2072 115.709C24.9314 118.274 22.3452 121.353 20.7935 124.945L26.8279 127.681C28.0348 125.116 29.9314 122.721 32.3452 120.84L33.8969 119.643C35.2762 118.617 35.4486 116.564 34.4141 115.196Z"
				fill="#48486A"
			/>
			<path
				opacity="0.3"
				d="M24.4136 152.142L24.9308 147.866C25.2756 144.958 25.4481 141.88 25.4481 138.972C25.7929 140.854 26.4825 142.564 27.517 144.274L33.5515 154.536C34.4136 156.076 33.8963 158.128 32.3446 158.983C31.8274 159.325 31.3101 159.496 30.6205 159.496C29.4136 159.496 28.3791 158.983 27.6894 157.786L24.4136 152.142Z"
				fill="#231F20"
			/>
			<path
				d="M37.5173 114.512L39.4139 115.538C45.7932 119.13 49.5863 123.406 49.5863 130.589L50.4483 132.471C51.4828 134.865 51.6552 137.602 50.7932 140.167L49.5863 144.101V168.388C43.7242 172.322 28.207 166.849 25.1035 160.52L25.9656 154.876C26.4828 151.455 26.6552 149.403 26.4828 145.982L25.6208 121.353C25.4483 115.538 32.1725 111.433 37.5173 114.512Z"
				fill="#48486A"
			/>
			<path
				d="M37.8627 116.396H37.0006C34.0696 116.396 31.4834 114.001 31.4834 110.923V97.0688H48.2075V105.963C48.2075 111.778 43.5524 116.396 37.8627 116.396Z"
				fill="#F2B1B5"
			/>
			<path
				d="M37.3453 121.185H37.0005C35.1039 121.185 33.7246 119.645 33.7246 117.935V108.528C33.7246 107.844 34.2419 107.331 34.9315 107.331H39.5867C40.2763 107.331 40.7936 107.844 40.7936 108.528V117.935C40.6212 119.645 39.0694 121.185 37.3453 121.185Z"
				fill="#F2B1B5"
			/>
			<path
				opacity="0.3"
				d="M49.5855 142.051C49.0682 141.88 47.8613 141.195 47.6889 139.656L46.3096 129.394C46.1372 127.684 44.413 126.315 42.6889 126.486C40.9648 126.657 40.7924 128.539 40.9648 130.42L41.1372 140.34C41.6544 144.103 44.2406 147.182 47.8613 148.208C48.3786 148.379 49.0682 148.55 49.5855 148.55V142.051Z"
				fill="#231F20"
			/>
			<path
				d="M50.793 147.008C49.9309 147.008 48.8965 146.837 47.862 146.666C44.2413 145.64 41.6551 142.561 41.1378 138.799L39.7585 128.537C39.5861 126.826 40.793 125.116 42.6896 124.945C44.4137 124.774 46.1378 125.971 46.3103 127.853L47.6896 138.115C47.862 139.825 49.4137 140.509 49.7585 140.509C50.2758 140.68 51.6551 141.022 52.862 139.654L62.3447 128.879C63.5516 127.51 65.6206 127.339 66.9999 128.537C68.3792 129.734 68.5516 131.786 67.3447 133.155L57.862 143.93C56.1378 145.811 53.5516 147.008 50.793 147.008Z"
				fill="#F2B1B5"
			/>
			<path
				d="M46.6554 127.171C46.3105 125.119 44.5864 123.75 42.5174 124.092C40.4485 124.434 39.0693 126.145 39.4141 128.197L40.9657 139.657L48.2072 138.801L46.6554 127.171Z"
				fill="#48486A"
			/>
			<path
				d="M60.9653 130.421L62.5171 128.71C63.724 127.342 65.7929 127.171 67.1722 128.368C68.5515 129.566 68.724 131.618 67.5171 132.986L65.6205 135.21L60.9653 130.421Z"
				fill="#F2B1B5"
			/>
			<path
				d="M66.655 133.668C68.845 133.668 70.6205 131.907 70.6205 129.734C70.6205 127.562 68.845 125.801 66.655 125.801C64.4648 125.801 62.6895 127.562 62.6895 129.734C62.6895 131.907 64.4648 133.668 66.655 133.668Z"
				fill="#F2B1B5"
			/>
			<path
				d="M70.1029 122.723L64.7581 128.367C64.5857 128.538 64.0684 128.538 63.896 128.367L63.5512 128.025C63.3788 127.854 63.3788 127.341 63.5512 127.17L68.896 121.526C69.0684 121.355 69.5857 121.355 69.7581 121.526L70.1029 121.868C70.4477 122.21 70.4477 122.552 70.1029 122.723Z"
				fill="#F2B1B5"
			/>
			<path
				d="M49.4139 93.8178C46.4828 90.3971 39.7587 91.4233 35.9656 92.6205C30.7932 94.3309 27.1725 97.5805 27.5173 103.396C27.6897 106.474 29.069 110.237 31.3104 112.289C34.069 114.855 37.6897 114.171 39.7587 111.263C40.6208 110.066 41.138 108.356 42.5173 107.501C43.5518 106.816 45.1035 106.816 45.6208 105.619C45.9656 104.764 45.4484 103.738 45.2759 102.883C44.9311 102.027 44.7587 100.83 45.4484 100.317C46.138 99.804 47.3449 100.146 48.0346 99.4619C48.5518 99.1198 49.2415 98.2647 49.5863 97.7515C50.7932 96.5543 50.6208 95.186 49.4139 93.8178Z"
				fill="#5C629E"
			/>
			<path
				d="M32.8622 104.765L32.1725 104.422C31.6553 102.37 29.7587 100.66 27.6898 99.8046C24.2415 98.4363 19.4139 100.66 17.8622 103.909C16.3105 106.988 18.207 112.461 19.5863 115.369C22.3449 121.013 28.0346 125.973 24.9311 132.643C24.5863 133.327 24.2415 134.183 24.5863 134.696C25.6208 136.235 27.6898 130.591 28.0346 130.078C29.4139 127.341 30.7932 124.776 30.4484 121.526C30.276 119.302 29.2415 117.421 28.8967 115.198C28.3794 113.145 28.7242 110.58 30.276 109.211C31.138 108.527 32.3449 108.014 33.0346 107.159C33.3794 106.475 33.3794 105.449 32.8622 104.765Z"
				fill="#5C629E"
			/>
			<g opacity="0.3">
				<path
					opacity="0.3"
					d="M32.8625 105.276C32.0005 106.302 30.966 105.105 29.9315 105.789C28.035 107.157 26.1384 109.552 26.3108 111.946C26.4832 114.341 27.5177 116.906 27.5177 119.301C27.5177 122.208 27.0005 128.194 25.6212 130.589C25.7936 132.128 25.6212 131.273 24.9315 132.812C24.5867 133.496 24.2419 134.352 24.5867 134.865C25.6212 136.404 27.6901 130.76 28.035 130.247C29.4143 127.51 30.7936 124.945 30.4487 121.695C30.2763 119.471 29.2419 117.59 28.897 115.367C28.3798 113.314 28.7246 110.749 30.2763 109.381C31.1384 108.696 32.3453 108.183 33.035 107.328C33.2074 106.644 33.3798 105.789 32.8625 105.276C33.035 105.105 33.035 105.276 32.8625 105.276Z"
					fill="#231F20"
				/>
			</g>
			<path
				d="M33.5526 105.792L33.3802 105.963C32.863 106.305 32.6905 105.792 32.5181 105.107C32.1733 104.252 31.6561 103.568 31.1388 102.884C30.794 102.371 30.2767 102.029 30.9664 101.687L31.1388 101.516C31.6561 101.174 32.1733 101.345 32.5181 101.858C33.2078 102.713 33.725 103.568 34.0698 104.594C34.2423 104.936 34.0699 105.45 33.5526 105.792Z"
				fill="url(#paint2_linear)"
			/>
		</g>
		<defs>
			<linearGradient
				id="paint0_linear"
				x1="48.5194"
				y1="105.961"
				x2="131.841"
				y2="105.961"
				gradientUnits="userSpaceOnUse">
				<stop stop-color="#D3DAED" />
				<stop offset="1" stop-color="#99A7D8" />
			</linearGradient>
			<linearGradient
				id="paint1_linear"
				x1="20.4896"
				y1="180.624"
				x2="50.5158"
				y2="180.624"
				gradientUnits="userSpaceOnUse">
				<stop offset="0.1499" stop-color="#FF9800" />
				<stop offset="1" stop-color="#FFC107" />
			</linearGradient>
			<linearGradient id="paint2_linear" x1="30.623" y1="103.62" x2="34.073" y2="103.62" gradientUnits="userSpaceOnUse">
				<stop offset="0.1499" stop-color="#FF9800" />
				<stop offset="1" stop-color="#FFC107" />
			</linearGradient>
			<clipPath id="clip0">
				<rect width="132.759" height="248" fill="white" transform="translate(0.620605)" />
			</clipPath>
		</defs>
	</svg>
);

export default Phone;
